type DebugSpec = boolean | "verbose";

let debug : DebugSpec = false;

/** Set debug messaging to true, false, or "verbose". */
export const setDebug = (
    value : DebugSpec = true
) => debug = value; 

/** Get current debug configuration value. */
export const getDebug = () => debug;

/** Debounce a function */
export const debounce = (
    func : (...args : any[]) => void, 
    delay = 100
) : any => {
    let timeoutId : number;
    
    return (...args : any) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => queueMicrotask(() => func(...args)), delay);
    };
}

const idMap = new Map();

/** Create an ID, potentially with a reference name and format. */
export const id = (
    idName = "", 
    idFormat : ((
        id: string, 
        idName? : string
    ) => string) = (id, idName?) => `${idName}${idName ? "-" : ""}${id}`
) => {
    const uniqueId = Math.random().toString(36).substring(2, 11);
    const id = idFormat(uniqueId, idName);
    idMap.set(idName, id);
    return id;
}

/** Get an ID by reference name. */
export const getId = (
    idName = ""
) => idMap.get(idName);

/** Log message helper function. */
export const logMessage = (
    value : any, 
    func : any
) => {
    let strValue = JSON.stringify(value) ?? "undefined";
    if(strValue.length > 80) {
        strValue = strValue.slice(0,77) + "...";
    }
    let strFunc = `${func}`;
    if(func.length > 80) {
        strFunc = strFunc.slice(0,77) + "...";
    }
    return `${strValue} ➤ ${strFunc}`;
}

/** Is the obj an instance of a function. */
export const isFunction = (
    obj : any
) => obj instanceof Function;

/** A value or a function that returns a value. */
export type Factor<T> = T | (() => T);

/** Evaluate a factor */
export const evalFactor = <T>(
    val : Factor<T>
) => isFunction(val) ? (val as () => T)() : val as T;

/** Typescript filter to specify the key of an object has a certain value type. */
export type KeyOf<Obj, Type> = {
    [K in keyof Obj]: Obj[K] extends Type ? K : never;
}[keyof Obj];

